export default "__VITE_ASSET__BHkdbBbK__"